import axios, { AxiosError, AxiosRequestConfig } from "axios";
import moment from "moment";
import crypto from "crypto";
import queryString from "query-string";
import NodeRSA from "node-rsa";
import { exceptionEventWeb } from "common/appInterface";
import stringUtils from "common/stringUtils";

const client = axios.create({
  baseURL: `${process.env.REACT_APP_WAS_IP}`,
  responseType: "json",
  withCredentials: true
});

client.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // 요청 성공 직전 호출됩니다.
    // axios 설정값을 넣습니다. (사용자 정의 설정도 추가 가능)

    let hmacKey = crypto.randomBytes(16).toString("hex");
    let rsa = new NodeRSA(Buffer.from(`${process.env.REACT_APP_PUBLIC_KEY}`, "base64"), "pkcs8-public-der");
    let authorization = rsa.encrypt(hmacKey, "base64");
    let method = config.method?.toLocaleUpperCase();
    let url = queryString.stringifyUrl({ url: config.url!, query: config.params }, { sort: false });
    let date = moment().utcOffset("+09:00").format("YYYYMMDDHHmmss");
    let body = method === "GET" ? "" : JSON.stringify(config.data);
    let hashBody = crypto.createHash("sha256").update(body).digest("base64");
    let signature = crypto.createHmac("sha256", hmacKey).update(method + url + date + hashBody).digest("base64");

    config.headers.common["x-gc-date"] = date;
    config.headers.common["x-gc-signature"] = signature;
    config.headers.common["x-gc-authorization"] = authorization;

    return config;
  }, 
  (error: AxiosError) => {
    // 요청 에러 직전 호출됩니다.
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => {
    // http status가 200인 경우
    // 응답 성공 직전 호출됩니다.
    // .then() 으로 이어집니다.
    return response;
  },
  (error: AxiosError) => {
    // http status가 200이 아닌 경우
    // 응답 에러 직전 호출됩니다.
    // .catch() 으로 이어집니다.

    if (error.response?.status === 401) {
      exceptionEventWeb(error.response.status.toString(), error.response.data.error + " [" + (stringUtils.nvlDefault(error.response.data.message, stringUtils.nvlDefault(error.response.headers['x-gc-error'], "Signature verify failure."))) + "]", "1");
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default client;